import { DeliverSchemaTypes } from "@bfc-software/api-schemas";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOnly,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

type Paths = DeliverSchemaTypes.paths;

/**
 * The dashboard endpoints (`/app/deliver/api/...`) take the AAA member session
 * JWT as a bearer token and no X-CLIENT-CODE (the `DashboardSession` scheme in
 * the fetched spec). The spec's paths already carry the `/app/deliver/api`
 * prefix, so the base is the bare service host.
 */
const spec = () => ({
  baseUrl: getEnv().deliverServiceBase,
  select: aaaTokenOnly,
});

export const useDeliverApi = () => useAuthenticatedApi<Paths>(spec());

/** Raw fetch client for imperative use, e.g. file exports. */
export const useDeliverFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());

export type DeliverFetchClient = ReturnType<typeof useDeliverFetchClient>;
